<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/index')">首页</a-breadcrumb-item>
      <a-breadcrumb-item href="" @click.native="() => $router.push('/sick-leave-list')">申请休假</a-breadcrumb-item>
      <a-breadcrumb-item>申请详情</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="content-box">
      <div class="detail-header">
        <h2>申请详情</h2>
        <div class="status-tag" :class="`status-${detailData.flowStatus}`">
          {{ detailData.flowStatus | refuseStatusFilter }}
        </div>
      </div>

      <a-spin :spinning="loading">
        <a-descriptions :column="2" bordered v-if="detailData.id">
          <a-descriptions-item label="申请人">{{ detailData.name }}</a-descriptions-item>
          <a-descriptions-item label="申请类型">{{ detailData.flowType | flowTypeFilter }}</a-descriptions-item>
          <a-descriptions-item label="学号">{{ detailData.studentNumber }}</a-descriptions-item>
          <a-descriptions-item label="手机号">{{ detailData.phone }}</a-descriptions-item>
          <a-descriptions-item label="性别">{{ detailData.gender | genderFilter }}</a-descriptions-item>
          <a-descriptions-item label="学历">{{ detailData.educationBackground }}</a-descriptions-item>
          <a-descriptions-item label="学院(系)">{{ detailData.college }}</a-descriptions-item>
          <a-descriptions-item label="专业">{{ detailData.specialty }}</a-descriptions-item>
          <a-descriptions-item label="班级">{{ detailData.classGrade }}</a-descriptions-item>
          <a-descriptions-item label="家庭住址">{{ detailData.address }}</a-descriptions-item>

          <template v-if="detailData.flowType == 1">
            <a-descriptions-item label="休学开始时间">{{ detailData.beginTime | dateToYMDFilter }}</a-descriptions-item>
            <a-descriptions-item label="休学结束时间">{{ detailData.endTime | dateToYMDFilter }}</a-descriptions-item>
            <a-descriptions-item label="休学情况说明" :span="2">{{ detailData.description }}</a-descriptions-item>
          </template>

          <template v-if="detailData.flowType == 2">
            <a-descriptions-item label="复学时间">{{ detailData.beginTime | dateToYMDFilter }}</a-descriptions-item>
            <a-descriptions-item label="复学情况说明" :span="2">{{ detailData.description }}</a-descriptions-item>
          </template>

          <template v-if="detailData.flowType == 4">
            <a-descriptions-item label="申请缓考理由" :span="2">{{ detailData.reason }}</a-descriptions-item>
            <a-descriptions-item label="缓考说明" :span="2">{{ detailData.description }}</a-descriptions-item>
          </template>

          <a-descriptions-item label="申请时间">{{ detailData.createTime }}</a-descriptions-item>
          <a-descriptions-item label="就诊医院">
            {{ detailData.visitType === 0 ? '校医院' : detailData.visitType === 1 ? '三方医院' : '-' }}
          </a-descriptions-item>
        </a-descriptions>

        <div
          v-if="detailData.flowType == 4 && detailData.deferredExamCourseList && detailData.deferredExamCourseList.length > 0"
          class="course-section">
          <h3>缓考课程列表</h3>
          <a-table :columns="courseColumns" :data-source="detailData.deferredExamCourseList" :pagination="false"
            bordered row-key="index"></a-table>
        </div>

        <!-- <div v-if="detailData.thirdMedicalRecordList && detailData.thirdMedicalRecordList.length > 0" class="image-section">
          <h3>上传图片</h3>
          <div class="image-list">
            <div class="image-item" v-for="(item, index) in detailData.thirdMedicalRecordList" :key="index" @click="previewImage(item.medicalRecordImage)">
              <img :src="item.medicalRecordImage" alt="图片" />
            </div>
          </div>
        </div> -->

        <div class="status-section" v-if="detailData.flowStatus != -1">
          <h3>审批状态</h3>
          <a-steps direction="vertical" :current="currentStep">
            <a-step title="提交申请" :description="`提交时间：${detailData.createTime}`"></a-step>
            <a-step title="防保科审批">
              <template slot="description">
                <span>{{ detailData.fbkStatus | refuseStatusFilter }}</span>
                <div class="refuse-reason">{{ detailData.fbkRefuseReason }}</div>
              </template>
            </a-step>
            <a-step title="院领导审批">
              <template slot="description">
                <span>{{ detailData.yldStatus | refuseStatusFilter }}</span>
                <div class="refuse-reason">{{ detailData.yldRefuseReason }}</div>
              </template>
            </a-step>
          </a-steps>
        </div>

        <div class="action-section" v-if="detailData.flowStatus == 2">
          <a-button type="primary" size="large" @click="goToEdit">补充资料</a-button>
          <a-button size="large" @click="goBack">返回</a-button>
        </div>

        <div class="action-section" v-else>
          <a-button size="large" @click="goBack">返回</a-button>
        </div>
      </a-spin>
    </div>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" width="80%">
      <img alt="preview" style="width: 100%" :src="previewImageUrl" />
    </a-modal>
  </div>
</template>

<script>
import { getApplicationFormDetail } from "@/api/sickLeave";

export default {
  data() {
    return {
      id: "",
      loading: false,
      detailData: {},
      previewVisible: false,
      previewImageUrl: "",
      courseColumns: [
        { title: "课程名称", dataIndex: "courseName", key: "courseName" },
        { title: "考试日期", dataIndex: "examinationDate", key: "examinationDate" }
      ]
    };
  },
  computed: {
    currentStep() {
      if (this.detailData.flowStatus == -1) {
        return 0;
      }
      if (this.detailData.flowStatus == 2) {
        if (this.detailData.fbkRefuseReason) {
          return 1;
        }
        if (this.detailData.yldRefuseReason) {
          return 2;
        }
      }
      if (this.detailData.flowStatus == 1) {
        return 3;
      }
      if (this.detailData.fbkStatus && !this.detailData.yldStatus) {
        return 1;
      }
      if (this.detailData.fbkStatus && this.detailData.yldStatus) {
        return 2;
      }
      return 0;
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.flowId = this.$route.query.flowId;
    if (this.id) {
      this.getDetail();
    }
  },
  filters: {
    refuseStatusFilter(v) {
      if (v === 1) {
        return "已同意";
      } else if (v === 0) {
        return "进行中";
      } else if (v === -1) {
        return "已取消";
      } else if (v === 2) {
        return "已拒绝";
      }
    },
  },
  methods: {
    async getDetail() {
      this.loading = true;
      try {
        const { code, data } = await getApplicationFormDetail({ formId: this.id });
        if (code == 200) {
          this.detailData = data || {};
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    previewImage(url) {
      this.previewImageUrl = url;
      this.previewVisible = true;
    },
    goToEdit() {
      this.$router.push({ path: "/sick-leave-add", query: { flowNo: this.id, id: this.flowId } });
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .content-box {
    max-width: 900px;
    margin: 30px auto;
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    h2 {
      margin: 0;
      font-size: 24px;
      color: #333;
    }

    .status-tag {
      padding: 6px 16px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;

      &.status-0 {
        background: #e6f7ff;
        color: #1890ff;
      }

      &.status-1 {
        background: #f6ffed;
        color: #52c41a;
      }

      &.status-2 {
        background: #fff2f0;
        color: #ff4d4f;
      }

      &.status--1 {
        background: #fafafa;
        color: #999;
      }
    }
  }

  .course-section,
  .image-section,
  .status-section {
    margin-top: 30px;

    h3 {
      font-size: 18px;
      color: #333;
      margin-bottom: 15px;
    }
  }

  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    .image-item {
      width: 150px;
      height: 150px;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      border: 1px solid #e3e3e3;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .status-section {
    .refuse-reason {
      color: #ff4d4f;
      margin-top: 5px;
    }
  }

  .action-section {
    margin-top: 40px;
    text-align: center;

    .ant-btn {
      width: 180px;
      margin: 0 10px;
    }
  }
}
</style>
